module.exports = __webpack_public_path__ + "media/images/editors-choice-0c123053772d1e8af313cf0c6db1838a.svg";